import MyBar from './bar/bar.vue';
import MyPie from './pie/pie.vue';
import MyLine from './line/line.vue';
import MyScatter from './scatter/scatter.vue';
import MyBarLine from './complexmychart/barline.vue';
import MyGauge from './gauge/gauge.vue';
import MyRadar from './radar/radar.vue';
import MyLiquidFill from './liquidfill/liquidfill.vue';
export {MyBar,MyPie,MyBarLine,MyLine,MyScatter,MyGauge,MyRadar,MyLiquidFill};


// WEBPACK FOOTER //
// ./src/components/mychart/index.js